import { Button, Divider, Grid, Menu, MenuItem, Tooltip, Typography } from '@material-ui/core';
import React, { ReactElement } from 'react';

interface IProps {
  titleRender: () => ReactElement;
  items: IMenuButtonItem[];
  minWidth: number;
  marginTop?: number;
  marginLeft?: number;
  disabled?: boolean;
  disabledMsg?: string;
  forceClosed?: boolean;
  // shows a grey background and font for the first item of the list (usually because the first row is the same as the menu row)
  enableGreyFirstItem?: boolean;
  enableDividers?: boolean;
  onClose?: () => void;
  // tracks open of menu button
  trackOnOpen?: () => void;
  // is menu open
  isMenuOpen?: boolean;
}

export interface IMenuButtonItem {
  closeOnClick: boolean;
  onClick?: () => void;
  render: () => ReactElement;
  isDivider?: boolean;
}

export const renderMenuTitle = () => {
  return (
    <Grid container direction='row' alignItems='center' spacing={1}>
      <Grid item>
        <Typography
          style={{
            marginLeft: -5,
            fontSize: '0.875rem',
            fontWeight: 500,
            color: 'black',
          }}
        >
          FILTERS
        </Typography>
      </Grid>
      <Grid item style={{ marginLeft: 10 }}>
        <svg
          id='noun_filter_787739'
          xmlns='http://www.w3.org/2000/svg'
          width='16.533'
          height='12.529'
          viewBox='0 0 16.533 12.529'
        >
          <g id='Group_379' data-name='Group 379'>
            <path
              id='Path_451'
              data-name='Path 451'
              d='M25.2,20.537a1.2,1.2,0,0,1-1.2,1.2H9.871a1.2,1.2,0,0,1-1.2-1.2h0a1.2,1.2,0,0,1,1.2-1.2H24a1.2,1.2,0,0,1,1.2,1.2Z'
              transform='translate(-8.667 -19.333)'
              fill='#434343'
            />
            <path
              id='Path_452'
              data-name='Path 452'
              d='M31.2,45.84a1.2,1.2,0,0,1-1.2,1.2H19.871a1.2,1.2,0,0,1-1.2-1.2h0a1.2,1.2,0,0,1,1.2-1.2H30a1.2,1.2,0,0,1,1.2,1.2Z'
              transform='translate(-16.667 -39.576)'
              fill='#434343'
            />
            <path
              id='Path_453'
              data-name='Path 453'
              d='M40.2,71.142a1.2,1.2,0,0,1-1.2,1.2H34.871a1.2,1.2,0,0,1-1.2-1.2h0a1.2,1.2,0,0,1,1.2-1.2H39a1.2,1.2,0,0,1,1.2,1.2Z'
              transform='translate(-28.667 -59.817)'
              fill='#434343'
            />
          </g>
        </svg>
      </Grid>
    </Grid>
  );
};

export const MenuButton = (props: IProps) => {
  const {
    titleRender,
    items,
    minWidth,
    marginLeft,
    marginTop,
    disabled,
    disabledMsg = '',
    forceClosed,
    enableGreyFirstItem,
    enableDividers,
    onClose,
    trackOnOpen,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
    if (trackOnOpen) {
      trackOnOpen();
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setAnchorEl(null);
  };

  const dividerRow = {
    closeOnClick: false,
    render: () => <div></div>,
    isDivider: true,
  };

  // add dividers between every item if enableDividers is true
  const menuItems = [] as IMenuButtonItem[];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    menuItems.push(item);
    // don't add for last row
    if (enableDividers && i !== items.length - 1) {
      menuItems.push(dividerRow);
    }
  }

  return (
    <Tooltip title={disabled && disabledMsg ? disabledMsg : ''} placement='top-start'>
      <Grid>
        <Button
          disabled={disabled}
          aria-controls='simple-menu'
          aria-haspopup='true'
          onClick={handleOpen}
        >
          {titleRender()}
        </Button>
        <Menu
          id='simple-menu'
          anchorEl={anchorEl}
          keepMounted
          open={!forceClosed && Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          PaperProps={{
            style: {
              width: minWidth ? minWidth : 200,
              marginTop: marginTop !== undefined ? marginTop : -1,
              marginLeft: marginLeft !== undefined ? marginLeft : -7,
              overflow: 'initial',
            },
          }}
        >
          {menuItems.map((item: IMenuButtonItem, i: number) => {
            if (item.isDivider) {
              return <Divider />;
            }
            return (
              <MenuItem
                onKeyDown={(e) => e.stopPropagation()}
                key={i}
                style={{
                  backgroundColor: i === 0 && enableGreyFirstItem ? 'rgba(0, 0, 0, 0.04)' : '',
                  width: '100%',
                  overflow: 'initial',
                }}
              >
                {item.render()}
              </MenuItem>
            );
          })}
        </Menu>
      </Grid>
    </Tooltip>
  );
};
